import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

import useUnreadConversationsStore from '%context/Chats/unreadConversations.store';
import {
	GetUnreadNotificationsCountDocument,
	useGetUnreadNotificationsCountQuery,
} from './__generated__/unreadNotificationsCount.generated';
import { useMarkAllReadMutation } from './__generated__/markAllNotificationsRead.mutation.generated';

const NOTIFICATIONS_COUNT_REFRESH_INTERVAL_IN_MS = 60 * 1000;

export const useUnreadNotificationsInfo = () => {
	const { navigate } = useNavigation();

	const unreadNotificationsCount = useGetUnreadNotificationsCountQuery({
		pollInterval: NOTIFICATIONS_COUNT_REFRESH_INTERVAL_IN_MS,
	}).data?.currentUser.unreadNotificationsCount;

	const [markRead] = useMarkAllReadMutation({
		refetchQueries: [GetUnreadNotificationsCountDocument],
	});

	const unreadConversationsCount = useUnreadConversationsStore(
		({ unreadConversationIds }) => unreadConversationIds.size,
	);

	const handleNotificationsBellClick = useCallback(() => {
		if (unreadNotificationsCount) {
			void markRead();
		}

		navigate('Notifications');
	}, [unreadNotificationsCount, markRead, navigate]);

	const handleConversationsClick = useCallback(() => navigate('Chats'), [navigate]);

	return {
		unreadNotificationsCount,
		unreadConversationsCount,
		handleNotificationsBellClick,
		handleConversationsClick,
	};
};
